export const BASE_URL = 'https://prod-api.onmyway.com'